module.exports = __webpack_public_path__ + "static/media/1.ab41d2e1.jpg";